import yowsClient from 'src/js/modules/service-client/yows-client';
import templates from 'src/js/modules/templates';
import errorModule from 'src/js/modules/error';

const fetchTemplatesData = (params) => async (dispatch, getState) => {
  const state = getState();
  const currentTemplatesData = templates.selectors.getTemplates(state);
  const currentResults = currentTemplatesData || [];

  try {
    const { data } = await yowsClient.get().listSiteConcepts(params);

    const shouldAppend = params.page && params.page > 1;

    const newTemplatesData = {
      ...data,
      results: shouldAppend ? [...currentResults, ...data.results] : data.results,
    };

    dispatch(templates.actions.setTemplatesData(newTemplatesData));
  } catch (error) {
    dispatch(
      errorModule.actions.setCriticalError({
        error,
        logSentry: true,
      })
    );

    throw error;
  }
};

export default fetchTemplatesData;
